var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Dropdown, FormLabel, MenuItem, Typography, } from '@one-thd/sui-atomic-components';
import { DateTime } from 'luxon';
import React, { useState } from 'react';
import { GetProfileDetails } from '../../api/b2b/account';
import { useBusinessToolsContext } from '../../hooks/useContexts';
import { pushEventInfo } from '../../utils/analytics';
import { DateSelectionDropdown } from '../shared/DateSelectionDropdown';
import '../../styles/business-tools.scss';
// TODO: Replace Luxon's DateTime.local().toLocaleString(DateTime.DATE_HUGE) with Day.js equivalent
// const formattedDate = dayjs().format('MMMM D, YYYY');
var createJobsMenu = function (jobsArray) {
    // push default jobName values as they are case sensitive
    var jobsArrayUpperCase = [];
    // array used to find indexOf default jobName
    var noDuplicateNamesToUpperCase = [];
    // sort jobName array
    var sortNames = [];
    // Change to upper case
    if (jobsArray) {
        for (var i = 0; i < jobsArray.length; i += 1) {
            if (jobsArray[i].jobName !== '') {
                jobsArrayUpperCase.push(typeof jobsArray[i] !== 'number'
                    ? jobsArray[i].jobName.toUpperCase()
                    : jobsArray[i].jobName);
                // find duplicates and don't add them to the arrays
                if (noDuplicateNamesToUpperCase.indexOf(jobsArrayUpperCase[i]) === -1 &&
                    jobsArrayUpperCase[i] !== '') {
                    noDuplicateNamesToUpperCase.push(jobsArrayUpperCase[i]);
                    sortNames.push(jobsArrayUpperCase[i]);
                }
            }
        }
    }
    sortNames.sort();
    // map over sortNames array
    return sortNames.map(function (data, i) {
        // stores indexOf value
        var index;
        if (typeof data !== 'number') {
            // find indexOf sorted item inside unsorted array
            index = noDuplicateNamesToUpperCase.indexOf(data);
            return (React.createElement(MenuItem, { value: noDuplicateNamesToUpperCase[index], key: i }, data));
        }
        // find numerical indexOf sorted item inside unsorted array
        index = noDuplicateNamesToUpperCase.indexOf(data);
        return (React.createElement(MenuItem, { value: noDuplicateNamesToUpperCase[index], key: i }, data));
    });
};
var renderPoJobNameElement = function (selectedPoJobName, setSelectedPoJobName, poJobNames, requestData, setRequestData) {
    return (React.createElement("div", null,
        React.createElement(FormLabel, { htmlFor: "jobSelect", id: "jobSelectLabel" }, "PO/Job Name"),
        React.createElement(Dropdown, { id: "jobSelect", "aria-labelledby": "jobSelectLabel", onChange: function (event) {
                var eventValue = event.target.value;
                pushEventInfo({
                    category: { primaryCategory: 'button submission' },
                    eventInfo: { eventName: 'my account settings' },
                    stash: {
                        myAccount: {
                            settings: 'track business spend: filter by job name',
                        },
                    },
                });
                if (setRequestData) {
                    if (eventValue !== 'all') {
                        setSelectedPoJobName(eventValue);
                        setRequestData(__assign(__assign({}, requestData), { poJobName: eventValue }));
                    }
                    if (eventValue === 'all') {
                        setSelectedPoJobName('all');
                        setRequestData(__assign(__assign({}, requestData), { poJobName: undefined }));
                    }
                }
            }, value: selectedPoJobName, style: { width: '100%', borderTop: '1px solid #999' } },
            React.createElement(MenuItem, { value: "all" }, "All PO/Job Names"),
            createJobsMenu(poJobNames))));
};
var getCombinedTotalSpend = function (topJobs) {
    var result = topJobs === null || topJobs === void 0 ? void 0 : topJobs.reduce(function (accumulator, job) {
        return accumulator + job.totalSpend;
    }, 0);
    return result === null || result === void 0 ? void 0 : result.toLocaleString('en', {
        minimumFractionDigits: 2,
    });
};
export var BusinessToolsHeader = function () {
    var _a, _b;
    var _c = useBusinessToolsContext(), jobSpends = _c.jobSpends, dateSelectorValue = _c.dateSelectorValue, setDateSelectorValue = _c.setDateSelectorValue, requestData = _c.requestData, setRequestData = _c.setRequestData;
    var profileData = GetProfileDetails().profileData;
    var _d = useState('all'), selectedPoJobName = _d[0], setSelectedPoJobName = _d[1];
    return (React.createElement("div", { className: "sui-grid sui-grid-cols-1  business-tools__topHeader" },
        React.createElement(Typography, { variant: "h2", weight: "display" }, (_b = (_a = profileData === null || profileData === void 0 ? void 0 : profileData.accountProfile) === null || _a === void 0 ? void 0 : _a.customerProfile) === null || _b === void 0 ? void 0 : _b.businessName),
        React.createElement("div", { className: "sui-flex sui-justify-between" },
            React.createElement("div", null,
                React.createElement("div", { className: "business-tools__topHeader__dateHeader" }, "Total Spend as of today"),
                React.createElement("div", { className: "business-tools__topHeader__dateFull" }, DateTime.local().toLocaleString(DateTime.DATE_HUGE))),
            React.createElement("div", { className: "business-tools__topHeader__headerTotalSpend" },
                React.createElement("span", { className: "business-tools__topHeader__headerDollarSign" }, "$"),
                getCombinedTotalSpend(jobSpends))),
        React.createElement("div", { className: "sui-flex sui-justify-between", style: { paddingTop: 10 } },
            React.createElement("div", { className: "sui-grid sm:sui-grid-cols-1 md:sui-grid-cols-1 lg:sui-grid-cols-2 sui-gap-2" },
                React.createElement(DateSelectionDropdown, { label: "View History From", dateSelectorValue: dateSelectorValue, setDateSelectorValue: setDateSelectorValue, page: "business-tools" }),
                renderPoJobNameElement(selectedPoJobName, setSelectedPoJobName, jobSpends, requestData, setRequestData)),
            React.createElement("div", null))));
};
